import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
//import "./Special/special.css";
import Button from 'react-bootstrap/Button';
import AwardCountsByPlayer from './award_counts_by_player';
import getTrophyInfo from '../../objects/CommonUse/get_trophy_info';
import MaximumAwardsDataset from './datasets/maximum_awards_dataset';

class AwardsExtraCreditModal extends Component {
  constructor(props) {
    super(props);
    this.state={
      }    
    this.userAwardArr = [];
    this.processBadgeArr();
    this.processAchievementsArr();
    this.processExtraCreditArr();
    this.addMaxEntry();
}

processBadgeArr(){
    for (let i=0; i<this.props.badgesArr.length; i++){
        const user = this.props.badgesArr[i].user;
        const badgeCount = this.props.badgesArr.length;
        const awardObj = {user: user, awardArr: [{awardType: "Badge", awardCount: badgeCount}]};
        this.userAwardArr.push(awardObj);
    }
}

processAchievementsArr(){
    for (let i=0; i<this.props.achievements.length; i++){
        const user = this.props.achievements[i].user;
        let userAwardArr = [];
        const achievementArr = this.props.achievements[i].achievementArr;
        for (let j=0; j<achievementArr.length; j++){
            if (achievementArr[j].earned === true){
                const achievementCode = achievementArr[j].achievementID.substring(0,1);
                const awardObj = getTrophyInfo(achievementCode);
                let medalType = awardObj.medalType;
                let awardIndx = -1;
                awardIndx = userAwardArr.findIndex(elem => elem.awardType === medalType);
                if (awardIndx === -1){
                    const awardArrObj = {awardType: medalType, awardCount: 1};
                    userAwardArr.push(awardArrObj);
                }else{
                    userAwardArr[awardIndx].awardCount += 1;
                }
            }
        }
        const awardIndx = this.userAwardArr.findIndex(elem => elem.user === user);
        if (awardIndx === -1){
            const awardObj = {user: user, awardArr: userAwardArr};
            this.userAwardArr.push(awardObj);
        }else{
            let newUserAwardArr = this.userAwardArr[awardIndx].awardArr;
            newUserAwardArr = newUserAwardArr.concat(userAwardArr);
            this.userAwardArr[awardIndx].awardArr = newUserAwardArr;
        }
    }
}

processExtraCreditArr() {
    // process extra credit - either add to badge line if category found ...OR... create new entry in array
    for (let i=0; i<this.props.extraCredit.length; i++){
        const user = this.props.extraCredit[i].user;
        const extraCreditCount = this.props.extraCredit[i].extraCreditTable.length;
        const awardIndx = this.userAwardArr.findIndex(elem => elem.user === user );
        const extraCreditObj = {awardType: "ExtraCredit", awardCount: extraCreditCount};
        if (awardIndx === -1){
            const awardObj = {user: user, awardArr: [extraCreditObj]};
            this.userAwardArr.push(awardObj);
        }else{
            this.userAwardArr[awardIndx].awardArr.push(extraCreditObj);
        }   
    } 
}

addMaxEntry(){
    const maximumAwards = MaximumAwardsDataset;
    this.userAwardArr.push(maximumAwards);
}


render() {
      const awardsExtraCreditInfo = this.userAwardArr.map((awards, index) =>
          <AwardCountsByPlayer awards={awards}  key={index}  
            playerAwardDetail={(player) => this.props.playerAwardDetail(player)}
            />
          );
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="lg" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Awards and Extra Credit Earned By Players </Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <span>
              <div className="ml-4 text-left">
                This display shows a summary of the number of badges, trophies and extra credit
                challenges that a player has earned/completed.  You can click on the player Name
                to view more detail.
              </div>
              <table className="table table-hover">
                <tbody>
                  <tr>
                    <th>Player Name</th>
                    <th>Badges Earned</th>
                    <th>Bronze Trophies</th>
                    <th>Silver Trophies</th>
                    <th>Gold Trophies</th>
                    <th>Jewels Earned</th>
                    <th>Extra Credit Completed</th>
                  </tr>
                  {awardsExtraCreditInfo}
                </tbody>
              </table>
                             
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
             
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }

}

export default AwardsExtraCreditModal;